import { Commitment } from "@/services/backend/relationships/types/relationship";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";
import { DateInput } from "@/shared/components/form/date-input";
import { NumberInput } from "@/shared/components/form/number-input";
import { TextInput } from "@/shared/components/form/text-input";

export function CommitmentCard({ commitment }: { commitment: Commitment }) {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Sollstellung")}</CardTitle>
        <CardDescription>
          {t("Informationen zur vorliegenden Sollstellung")}
        </CardDescription>
      </CardHeader>
      <CardContent className="grid grid-cols-2 gap-4">
        <DateInput
          label={t("Datum")}
          date={commitment.date}
          onDateChange={() => null}
          disabled
        />
        <TextInput
          label={t("Dienstleistung")}
          field="serviceKind"
          text={commitment.serviceKind}
          onTextChange={() => null}
          errors={[]}
          disabled
        />
        <div className="grid grid-cols-2 gap-4">
          <NumberInput
            label={t("Turnus")}
            field="cycle"
            number={commitment.cycle}
            onNumberChange={() => null}
            errors={[]}
            disabled
          />
          <NumberInput
            label={t("Manntage")}
            field="plannedHours"
            number={Number((commitment.plannedHours / 8.0).toFixed(2))}
            onNumberChange={() => null}
            errors={[]}
            disabled
          />
        </div>
        <TextInput
          label={t("Status")}
          field="status"
          text={t(commitment.status)}
          onTextChange={() => null}
          errors={[]}
          disabled
        />
      </CardContent>
    </Card>
  );
}
